import useRoute from './useRoute'

export default useRoute
